import React, { memo } from 'react';
import { Eye16Regular } from '@fluentui/react-icons';
import BlockMarkdown from '../structured/BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockMarkdown } from '../structured/structuredBlockUtils';
import styles from './consultantReport.module.css';

function ExecutiveSummaryCard({ block, renderContext }) {
    const content = extractBlockMarkdown(block);
    if (!content) return null;
    const takeaway = block.takeaway || block.highlight || block.key_takeaway;

    return (
        <article className={styles.executiveSummaryCard}>
            {renderContext?.onViewEvidence ? (
                <div className={`${styles.executiveSummaryActions} noPrint`}>
                    <button
                        type="button"
                        className={styles.viewEvidenceBtn}
                        onClick={renderContext.onViewEvidence}>
                        <Eye16Regular aria-hidden />
                        View evidence
                    </button>
                </div>
            ) : null}
            <div className={styles.executiveSummaryLead}>
                <BlockMarkdown content={content} {...renderContext} />
            </div>
            {takeaway ? <aside className={styles.takeawayBox}>{takeaway}</aside> : null}
            <ClaimSupportFooter block={block} renderContext={renderContext} />
        </article>
    );
}

export default memo(ExecutiveSummaryCard);
